<template>
  <b-modal
    ref="modal"
    title="ข้อตกลงการประมวลผลข้อมูลส่วนบุคคล (DPA) — AI Assistant"
    size="lg"
    scrollable
    no-close-on-backdrop
    @hidden="agreed = false"
  >
    <p>
      ก่อนเปิดใช้งาน AI Assistant ของ <strong>{{ clinicName }}</strong>
      กรุณาอ่านและยอมรับข้อตกลงฉบับ {{ dpa.currentVersion }}
    </p>
    <ul>
      <li>
        คลินิกเป็น <strong>ผู้ควบคุมข้อมูลส่วนบุคคล</strong> และ Tantatat เป็น
        <strong>ผู้ประมวลผลข้อมูลส่วนบุคคล</strong> ตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล (PDPA)
      </li>
      <li>
        เมื่อผู้ใช้เชื่อมต่อ AI ข้อมูลของคลินิก <strong>รวมถึงข้อมูลคนไข้</strong> ตามสิทธิ์ของผู้ใช้คนนั้น
        จะถูกส่งไปยังผู้ให้บริการ AI ที่ผู้ใช้เลือก (เช่น Claude หรือ ChatGPT)
      </li>
      <li>แนะนำให้ใช้บัญชี AI แบบ Team / Enterprise หรือปิดการนำข้อมูลไปใช้ฝึกโมเดล</li>
      <li>
        AI อ่านข้อมูลได้อย่างเดียว ใช้ได้เฉพาะผู้จัดการสาขาและผู้บริหาร ทุกการเรียกใช้ถูกบันทึกไว้ 365 วัน
        และคลินิกยกเลิกการเชื่อมต่อของผู้ใช้ได้ทุกเมื่อ
      </li>
    </ul>
    <p v-if="dpa.url">
      <a :href="dpa.url" target="_blank" rel="noopener noreferrer">
        <i class="fas fa-file-contract mr-1"></i>อ่านข้อตกลงฉบับเต็ม
      </a>
    </p>
    <b-form-checkbox v-model="agreed">ข้าพเจ้าได้อ่านและยอมรับข้อตกลงนี้ในนามของคลินิก</b-form-checkbox>
    <template #modal-footer="{ cancel }">
      <b-button variant="outline-secondary" @click="cancel()">ยกเลิก</b-button>
      <b-button variant="primary" :disabled="!agreed" @click="accept">ยอมรับและเปิดใช้งาน</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "McpDpaModal",
  props: {
    dpa: { type: Object, required: true },
    clinicName: { type: String, default: "" },
  },
  data() {
    return { agreed: false };
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    accept() {
      this.$refs.modal.hide();
      this.$emit("accepted");
    },
  },
};
</script>
